export default __webpack_public_path__ + "static/media/AirFilter.c88fb008.svg";